module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-01.e0799336.svg";